import { useState, useEffect } from 'react';
import { useAuthStore } from '../stores/authStore';

/**
 * Custom hook that handles demo login via URL hash.
 * 
 * Extracts demo_email from window.location.hash synchronously
 * (via useState lazy init) to prevent ProtectedRoute redirecting
 * to /login before the useEffect fires.
 * 
 * @returns {{ pendingDemo: boolean }}
 */
export function useDemoLogin() {
    const { checkAuth, demoLogin } = useAuthStore();

    // Synchronous detection — prevents flash of login page
    const [pendingDemo, setPendingDemo] = useState(() => {
        return window.location.hash.includes('demo_email=');
    });

    useEffect(() => {
        const hash = window.location.hash;
        if (hash.includes('demo_email=')) {
            const params = new URLSearchParams(hash.substring(1));
            const email = params.get('demo_email') || '';
            window.history.replaceState(null, '', window.location.pathname);
            demoLogin(email).finally(() => setPendingDemo(false));
            return; // Don't also call checkAuth
        }
        checkAuth();
    }, []);

    return { pendingDemo };
}
